export const isStage = window.location.hostname.includes("stage.");
export const isProd =
  !isStage && window.location.hostname.includes("northhouse.se");
export const isLocal = !isProd && !isStage;

export const customer = window.location.hostname.split(".")[0];
